import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GoogleMap, PlainContentModuleContainer, TextContentBlock, useContentModule } from "@silvertours/front-entities";
import { Ui } from "@silvertours/front-shared";
import { APIProvider as GoogleMapsAPIProvider } from "@vis.gl/react-google-maps";
export var StationsMap = function(_param) {
    var content = _extends({}, _param);
    var getStationsMap = useContentModule().getStationsMap;
    var ref = getStationsMap(), stations = ref.stations, boundingBox = ref.boundingBox;
    var _NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
    return stations && stations.length > 0 ? /*#__PURE__*/ _jsxs(PlainContentModuleContainer, {
        children: [
            /*#__PURE__*/ _jsx(TextContentBlock, {
                content: content,
                rules: {
                    textStyle: {
                        style: Ui.RichTextStyle.Primary
                    },
                    isContainerMultiColumn: false
                }
            }),
            /*#__PURE__*/ _jsx(GoogleMapsAPIProvider, {
                apiKey: (_NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY) !== null && _NEXT_PUBLIC_GOOGLE_MAPS_API_KEY !== void 0 ? _NEXT_PUBLIC_GOOGLE_MAPS_API_KEY : "",
                children: /*#__PURE__*/ _jsx(GoogleMap, _object_spread_props(_object_spread({}, boundingBox ? {
                    bbox: boundingBox
                } : {}), {
                    stations: stations
                }))
            })
        ]
    }) : null;
};
